export const PERMS = {
    READ: 'customer_address_types.read',
    UPDATE: 'customer_address_types.update',
    DELETE: 'customer_address_types.delete',
    CREATE: 'customer_address_types.create',
    EXPORT: 'customer_address_types.export',
}
